import { ChevronDownIcon } from "@chakra-ui/icons";
import {
  Menu, MenuButton, MenuList, MenuButtonProps, MenuProps, Portal,
  Button,
  MenuListProps,
} from "@chakra-ui/react";
import { PropsWithChildren } from "react";

interface ButtonMenuProps extends PropsWithChildren, MenuButtonProps {
  buttonComponent: typeof Button;
  label: string;
  ariaLabel: string;
  menuFontSize?: MenuListProps["fontSize"];
  menuProps?: Omit<MenuProps, "children">;
  inPortal?: boolean;
  includeIcon?: boolean;
}

export default function ButtonMenu({
  buttonComponent: ButtonComponent, label, ariaLabel, menuFontSize, inPortal = false, children, menuProps = {}, includeIcon = false, ...rest
}: ButtonMenuProps) {
  return (
    <Menu {...menuProps}>
      <MenuButton
        as={ButtonComponent}
        aria-label={ariaLabel}
        rightIcon={includeIcon ? <ChevronDownIcon /> : null}
        {...rest}
      >
        {label}
      </MenuButton>
      {inPortal ? (
        <Portal>
          <MenuList fontSize={menuFontSize}>{children}</MenuList>
        </Portal>
      ) : (
        <MenuList fontSize={menuFontSize}>{children}</MenuList>
      )}
    </Menu>
  );
}
